import { MDBAlert, MDBBtn, MDBIcon, MDBModalFooter } from 'mdb-react-ui-kit';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { deletePhoneDevice } from '../../../apiclients/streamsapi_bridge';

const UnassignedRemoveDevice = (props) => {
    console.log("UnassignedRemoveDevice   ::::::: " + JSON.stringify(props));
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [isError, setError] = useState(false);

    const handleSubmit = async () => {
        try {
            console.log("[removeUnAssignDevice] macAddress ::: " + props.param.macAddress);
            let params = {
                reqid: 21,
                device_macadress: props.param.macAddress,
                siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid
            };
            let servres = await deletePhoneDevice(params.siteid, params);
            if (!servres.ok) {
                console.log("got an issue while removing the device");
                setError(true);
            } else {
                props.fetchData();
                props.setDeviceRemoved(true);
                setTimeout(() => {
                    props.setDeviceRemoved(false);
                }, 10000);
                props.onClose();

            }
        } catch (error) {
            console.error(error);
            setError(true);
        }
    };

    return (
        <>
            {isError && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="danger"
                    autohide
                    position="bottom-right"
                    delay={100000}
                >
                    Internal Server Error
                </MDBAlert>
            )}
            <div className="d-flex align-items-center bg-danger bg-opacity-25 p-3  rounded-3 square border border-2 border-danger">
                <MDBIcon fas icon="ban" className="me-3" size="lg" color="danger" />
                <span>{t("removeDevicetext")} </span>
            </div>

            {/* {isError && (
                <div className='d-flex flex-wrap pb-2'>
                    {t("An error occurred while removing the device.")}
                </div>
            )} */}
            <MDBModalFooter className='p-0 mt-2 pt-2'>
                <MDBBtn
                    color="secondary"
                    className="cancel-btn"
                    onClick={(e) => props.onClose(e)}>
                    {t("close")}
                </MDBBtn>
                <MDBBtn onClick={handleSubmit}>
                    {t("remove")}
                </MDBBtn>
            </MDBModalFooter>
        </>
    );
};

export default UnassignedRemoveDevice;
